import e from"./use-resize";export default e;